import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Input, Button, Card, Typography } from "antd";
import { FaRobot, FaTimes, FaExpand } from "react-icons/fa";

const { Text } = Typography;

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [mediumSize, setMediumSize] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);

  const BACKEND_URL =
    "https://fancity-backend-i3f6u82ly-komal-anums-projects.vercel.app/api/yallaNellab/chat";

  const toggleOpen = () => setOpen(!open);
  const toggleSize = () => setMediumSize(!mediumSize);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");

    try {
      const response = await axios.post(BACKEND_URL, { message: input });
      const botMessage = { sender: "bot", text: response.data.reply };
      setMessages((prev) => [...prev, botMessage]);
    } catch (err) {
      const botMessage = { sender: "bot", text: "Oops! Something went wrong." };
      setMessages((prev) => [...prev, botMessage]);
      console.error(err);
    }
  };

  const handleKeyDown = (e) => e.key === "Enter" && sendMessage();

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const themeColor = "rgb(110, 69, 152)";
  const isMobile = window.innerWidth < 600;

  const chatWidth = open ? (isMobile ? "90vw" : mediumSize ? 600 : 400) : 60;
  const chatHeight = open ? (isMobile ? "75vh" : mediumSize ? 600 : 500) : 60;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        width: chatWidth,
        height: chatHeight,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        borderRadius: 16,
        overflow: "hidden",
        transition: "all 0.3s ease",
        boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
        backgroundColor: "#fff",
      }}
    >
      {open ? (
        <>
          <Card
            size="small"
            bodyStyle={{
              padding: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: themeColor,
              color: "#fff",
            }}
          >
            <Text style={{ color: "#fff", fontWeight: 600 }}>Yalla Nellab Chat</Text>
            <div style={{ display: "flex", gap: 8 }}>
              {!isMobile && (
                <Button type="text" onClick={toggleSize} style={{ color: "#fff" }}>
                  <FaExpand />
                </Button>
              )}
              <Button type="text" onClick={toggleOpen} style={{ color: "#fff" }}>
                <FaTimes />
              </Button>
            </div>
          </Card>

          {/* ✅ Chat Messages */}
          <div style={{ flex: 1, overflowY: "auto", padding: "10px", background: "#fafafa" }}>
            {messages.map((msg, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    backgroundColor: msg.sender === "user" ? themeColor : "#f1f1f1",
                    color: msg.sender === "user" ? "#fff" : "#333",
                    padding: "10px 14px",
                    borderRadius:
                      msg.sender === "user"
                        ? "14px 14px 4px 14px"
                        : "14px 14px 14px 4px",
                    maxWidth: "70%",
                    width: "fit-content",
                    lineHeight: "1.4em",
                    fontSize: "14px",
                    fontWeight: 500,
                    border: msg.sender === "bot" ? "1px solid #dcdcdc" : "none",
                    wordWrap: "break-word",
                  }}
                >
                  {msg.text}
                </div>
              </div>
            ))}

            <div ref={messagesEndRef} />
          </div>

          {/* ✅ Input Box */}
          <div style={{ display: "flex", padding: 10, background: "#fff" }}>
            <Input
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{
                flex: 1,
                marginRight: 8,
                borderRadius: 20,
                borderColor: themeColor,
              }}
            />
            <Button
              type="primary"
              onClick={sendMessage}
              style={{
                borderRadius: 20,
                backgroundColor: themeColor,
                borderColor: themeColor,
                fontWeight: 600,
              }}
            >
              Send
            </Button>
          </div>
        </>
      ) : (
        <Button
          type="primary"
          size="large"
          onClick={toggleOpen}
          style={{
            width: 60,
            height: 60,
            backgroundColor: themeColor,
            borderColor: themeColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 22,
          }}
        >
          <FaRobot />
        </Button>
      )}
    </div>
  );
};

export default Chatbot;
